import React, {useEffect, useState} from 'react';
import {ToastContainer} from "react-toastify";
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import {Link} from "react-router-dom";

import Spinner from "reactjs-simple-spinner";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
}));


const Reports = (props) => {

    const classes = useStyles();

    const [loading, setLoading] = useState(true);
    const [initiate, setInitiate] = useState(false);

    const stopLoading = () => {
        setLoading(false)
    }

    useEffect(() => {
        let role_based_perm = JSON.parse(localStorage.getItem('role_based_permissions'));
        let direct_perm = JSON.parse(localStorage.getItem('direct_permissions'));
        console.log("role_based: ", role_based_perm);
        console.log("direct perm: ", direct_perm);
        if (role_based_perm === null || role_based_perm === undefined) {
            setInitiate(false);
        } else {
            role_based_perm.map((perm, i) => {
                if (perm.name === 'initiate claim') {
                    setInitiate(true);
                }
            })
        }
        if (direct_perm === null || direct_perm === undefined) {
            setInitiate(false);
        } else {
            direct_perm.map((perm, i) => {
                if (perm.name === 'initiate claim') {
                    setInitiate(true);
                }
            })
        }


        setTimeout(stopLoading, 3000);
    }, [])



    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div id="main-content" className="main-panel ps-container ps-theme-default">
                <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                <div className="content">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                            &nbsp;|&nbsp;
                            Reports
                        </ul>
                        {loading && (
                            <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                <Spinner
                                    size="medium"
                                    message="Please wait....."
                                    line-fg-color="#64c3c2"
                                />
                            </div>
                        )}
                        {!loading && (
                            <div className="row mt">
                                <div className="col-lg-12">
                                    {/*    tabs*/}
                                    <div className={classes.root}>
                                        <div className="row">
                                                    <div className="col-md-12 container">
                                                        <div className="row  p-5 mb-1">
                                                            <div className="col-md-3 p-4 mt-md-0 mr-5" style={{
                                                                backgroundColor: "#f6f3f3",
                                                                borderRadius: '2.5%'
                                                            }}>
                                                                <a href={'/death-claims-report'}>
                                                                    <div className="move-on-hover">
                                                                        <i className="fa-solid fa-car-burst fa-2x"></i>
                                                                    </div>
                                                                    <div className="mt-2 ms-2">
                                                                        <h4 className="mb-0">Death Claims</h4>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            {/*<div className="col-md-3 p-4 mt-md-0 mr-5" style={{*/}
                                                            {/*    backgroundColor: "#f6f3f3",*/}
                                                            {/*    borderRadius: '2.5%'*/}
                                                            {/*}}>*/}
                                                            {/*    <a href={'/death-claims-per-product'}>*/}
                                                            {/*        <div className="move-on-hover">*/}
                                                            {/*            <i className="fa-solid fa-car-burst fa-2x"></i>*/}
                                                            {/*        </div>*/}
                                                            {/*        <div className="mt-2">*/}
                                                            {/*            <h4 className="mb-0">Death Claims Per Product</h4>*/}
                                                            {/*        </div>*/}
                                                            {/*    </a>*/}
                                                            {/*</div>*/}
                                                            <div className="col-md-3 p-4 mt-md-0 mr-5" style={{
                                                                backgroundColor: "#f6f3f3",
                                                                borderRadius: '2.5%'
                                                            }}>
                                                                <a href={'/investment-claims'}>
                                                                    <div className="move-on-hover">
                                                                        <i className="fa-solid fa-chart-line fa-2x"></i>
                                                                    </div>
                                                                    <div className="mt-2 ms-2">
                                                                        <h4 className="mb-0">Investment Claims</h4>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div className="col-md-3 p-4 mt-md-0 mr-5" style={{
                                                                backgroundColor: "#f6f3f3",
                                                                borderRadius: '2.5%'
                                                            }}>
                                                                <a href={'/inotho-claims'}>
                                                                    <div className="move-on-hover">
                                                                        <i className="fa-solid fa-cow fa-2x"></i>
                                                                    </div>
                                                                    <div className="mt-2 ms-2">
                                                                        <h4 className="mb-0">Pfuma / Inotho Claims</h4>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div className="row  p-5 mb-1">
                                                            <div className="col-md-3 p-4 mt-md-0 mr-5" style={{
                                                                backgroundColor: "#f6f3f3",
                                                                borderRadius: '2.5%'
                                                            }}>
                                                                <a href={'/accident-claims-report'}>
                                                                    <div className="move-on-hover">
                                                                        <i className="fa-solid fa-car-burst fa-2x"></i>
                                                                    </div>
                                                                    <div className="mt-2 ms-2">
                                                                        <h4 className="mb-0">Accident Claims</h4>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div className="col-md-3 p-4 mt-md-0 mr-5" style={{
                                                                backgroundColor: "#f6f3f3",
                                                                borderRadius: '2.5%'
                                                            }}>
                                                                <a href={'/comprehensive-claims-report'}>
                                                                    <div className="move-on-hover">
                                                                        <i className="fa-solid fa-hands-holding-child fa-2x"></i>
                                                                    </div>
                                                                    <div className="mt-2">
                                                                        <h4 className="mb-0">Comprehensive Claims</h4>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div className="col-md-3 p-4 mt-md-0 mr-5" style={{
                                                                backgroundColor: "#f6f3f3",
                                                                borderRadius: '2.5%'
                                                            }}>
                                                                <a href={'/standard-funeral-claims-report'}>
                                                                    <div className="move-on-hover">
                                                                        <i className="fa-solid fa-truck-medical fa-2x"></i>
                                                                    </div>
                                                                    <div className="mt-2 ms-2">
                                                                        <h4 className="mb-0">Standard Funeral Claims</h4>
                                                                    </div>
                                                                </a>
                                                            </div>

                                                        </div>
                                                        <div className="row  p-5 mb-1">
                                                            <div className="col-md-3 p-4 mt-md-0 mr-5" style={{
                                                                backgroundColor: "#f6f3f3",
                                                                borderRadius: '2.5%'
                                                            }}>
                                                                <a href={'/claims-paid-analysis'}>
                                                                    <div className="move-on-hover">
                                                                        <i className="fa-solid fa-briefcase-medical fa-2x"></i>
                                                                    </div>
                                                                    <div className="mt-2 ms-2">
                                                                        <h4 className="mb-0">Claims Paid Analysis</h4>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div className="col-md-3 p-4 mt-md-0 mr-5" style={{
                                                                backgroundColor: "#f6f3f3",
                                                                borderRadius: '2.5%'
                                                            }}>
                                                                <a href={'/premium-analysis-by-policy-type'}>
                                                                    <div className="move-on-hover">
                                                                        <i className="fa-solid fa-building-shield fa-2x"></i>
                                                                    </div>
                                                                    <div className="mt-2 ms-2">
                                                                        <h4 className="mb-0">Premium Analysis by Policy
                                                                            Type</h4>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div className="col-md-3 p-4 mt-md-0 mr-5" style={{
                                                                backgroundColor: "#f6f3f3",
                                                                borderRadius: '2.5%'
                                                            }}>
                                                                <a href={'/premium-analysis-by-industry'}>
                                                                    <div className="move-on-hover">
                                                                        <i className="fa-solid fa-industry fa-2x"></i>
                                                                    </div>
                                                                    <div className="mt-2">
                                                                        <h4 className="mb-0">Premium Analysis by
                                                                            Industry</h4>
                                                                    </div>
                                                                </a>
                                                            </div>

                                                        </div>
                                                        <div className="row  p-5 mb-1">

                                                            <div className="col-md-3 p-4 mt-md-0 mr-5" style={{
                                                                backgroundColor: "#f6f3f3",
                                                                borderRadius: '2.5%'
                                                            }}>
                                                                <a href={'/premium-analysis-by-aggregator'}>
                                                                    <div className="move-on-hover">
                                                                        <i className="fa-solid fa-people-line fa-2x"></i>
                                                                    </div>
                                                                    <div className="mt-2 ms-2">
                                                                        <h4 className="mb-0">Premium Analysis by
                                                                            Aggregator</h4>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div className="col-md-3 p-4 mt-md-0 mr-5" style={{
                                                                backgroundColor: "#f6f3f3",
                                                                borderRadius: '2.5%'
                                                            }}>
                                                                <a href={'/payment-history'}>
                                                                    <div className="move-on-hover">
                                                                        <i className="fa-solid fa-file-invoice-dollar fa-2x"></i>
                                                                        <i className="fa-solid fa-clock-rotate-left fa-2x"></i>
                                                                    </div>
                                                                    <div className="mt-2 ms-2">
                                                                        <h4 className="mb-0">Payment History</h4>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div className="col-md-3 p-4 mt-md-0 mr-5" style={{
                                                                backgroundColor: "#f6f3f3",
                                                                borderRadius: '2.5%'
                                                            }}>
                                                                <a href={'/list-of-accounts'}>
                                                                    <div className="move-on-hover">
                                                                        <i className="fa-solid fa-receipt fa-2x"></i>
                                                                    </div>
                                                                    <div className="mt-2 ms-2">
                                                                        <h4 className="mb-0">List of Accounts
                                                                            Documents</h4>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div className="row  p-5 mb-1">

                                                            <div className="col-md-3 p-4 mt-md-0 mr-5" style={{
                                                                backgroundColor: "#f6f3f3",
                                                                borderRadius: '2.5%'
                                                            }}>
                                                                <a href={'/savings-policies-due-to-mature'}>
                                                                    <div className="move-on-hover">
                                                                        <i className="fa-solid fa-piggy-bank fa-2x"></i>
                                                                    </div>
                                                                    <div className="mt-2 ms-2">
                                                                        <h4 className="mb-0">Savings Policies Due To
                                                                            Mature</h4>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div className="col-md-3 p-4 mt-md-0 mr-5" style={{
                                                                backgroundColor: "#f6f3f3",
                                                                borderRadius: '2.5%'
                                                            }}>
                                                                <a href={'/inotho-policies-due-to-mature'}>
                                                                    <div className="move-on-hover">
                                                                        <i className="fa-solid fa-cow fa-2x"></i>
                                                                    </div>
                                                                    <div className="mt-2 ms-2">
                                                                        <h4 className="mb-0">Pfuma / Inotho Policies Due
                                                                            To Mature</h4>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div className="col-md-3 p-4 mt-md-0 mr-5" style={{
                                                                backgroundColor: "#f6f3f3",
                                                                borderRadius: '2.5%'
                                                            }}>
                                                                <a href={'/revenue-report'}>
                                                                    <div className="move-on-hover">
                                                                        <i className="fa-solid fa-chart-bar fa-2x"></i>
                                                                    </div>
                                                                    <div className="mt-2">
                                                                        <h4 className="mb-0">Revenue Report</h4>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                        {/*<div className="row  p-5 mb-1">*/}
                                                        {/*    <div className="col-md-3 p-4 mt-md-0 mr-5" style={{*/}
                                                        {/*        backgroundColor: "#f6f3f3",*/}
                                                        {/*        borderRadius: '2.5%'*/}
                                                        {/*    }}>*/}
                                                        {/*        <a href={'#'}>*/}
                                                        {/*            <div className="move-on-hover">*/}
                                                        {/*                <i className="fa-solid fa-repeat fa-2x"></i>*/}
                                                        {/*            </div>*/}
                                                        {/*            <div className="mt-2">*/}
                                                        {/*                <h4 className="mb-0">Reassurance Report</h4>*/}
                                                        {/*            </div>*/}
                                                        {/*        </a>*/}
                                                        {/*    </div>*/}
                                                        {/*    <div className="col-md-3 p-4 mt-md-0 mr-5" style={{*/}
                                                        {/*        backgroundColor: "#f6f3f3",*/}
                                                        {/*        borderRadius: '2.5%'*/}
                                                        {/*    }}>*/}
                                                        {/*        <a href={'/reassurance-recoveries'}>*/}
                                                        {/*            <div className="move-on-hover">*/}
                                                        {/*                <i className="fa-solid fa-hammer fa-2x"></i>*/}
                                                        {/*            </div>*/}
                                                        {/*            <div className="mt-2">*/}
                                                        {/*                <h4 className="mb-0">Reassurance Recoveries</h4>*/}
                                                        {/*            </div>*/}
                                                        {/*        </a>*/}
                                                        {/*    </div>*/}
                                                        {/*    <div className="col-md-3 p-4 mt-md-0 mr-5" style={{*/}
                                                        {/*        backgroundColor: "#f6f3f3",*/}
                                                        {/*        borderRadius: '2.5%'*/}
                                                        {/*    }}>*/}
                                                        {/*        <a href={'/ex-gratia-claims'}>*/}
                                                        {/*            <div className="move-on-hover">*/}
                                                        {/*                <i className="fa-solid fa-house-medical-circle-exclamation fa-2x"></i>*/}
                                                        {/*            </div>*/}
                                                        {/*            <div className="mt-2 ms-2">*/}
                                                        {/*                <h4 className="mb-0">Ex gratia Claims</h4>*/}
                                                        {/*            </div>*/}
                                                        {/*        </a>*/}
                                                        {/*    </div>*/}
                                                        {/*</div>*/}

                                                        <div className="row  p-5 mb-1">

                                                        <div className="col-md-3 p-4 mt-md-0 mr-5" style={{
                                                                backgroundColor: "#f6f3f3",
                                                                borderRadius: '2.5%'
                                                            }}>
                                                                <a href={'/commission-reports'}>
                                                                    <div className="move-on-hover">
                                                                        <i className="fa-solid fa-percent fa-2x"></i>
                                                                    </div>
                                                                    <div className="mt-2 ms-2">
                                                                        <h4 className="mb-0">Commissions Report</h4>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div className="col-md-3 p-4 mt-md-0 mr-5" style={{
                                                                backgroundColor: "#f6f3f3",
                                                                borderRadius: '2.5%'
                                                            }}>
                                                                <a href={'/risk-profiles'}>
                                                                    <div className="move-on-hover">
                                                                        <i className="fa-solid fa-person-arrow-up-from-line fa-2x"></i>
                                                                    </div>
                                                                    <div className="mt-2 ms-2">
                                                                        <h4 className="mb-0">Risk Profiles</h4>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div className="col-md-3 p-4 mt-md-0 mr-5" style={{
                                                                backgroundColor: "#f6f3f3",
                                                                borderRadius: '2.5%'
                                                            }}>
                                                                <a href={'/leads'}>
                                                                    <div className="move-on-hover">
                                                                        <i className="fa-solid fa-users fa-2x"></i>
                                                                    </div>
                                                                    <div className="mt-2 ms-2">
                                                                        <h4 className="mb-0">Policy Holder Analysis</h4>
                                                                    </div>

                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div className="row  p-5 mb-1">

                                                            <div className="col-md-3 p-4 mt-md-0 mr-5" style={{
                                                                backgroundColor: "#f6f3f3",
                                                                borderRadius: '2.5%'
                                                            }}>
                                                                <a href={'/deleted_policies'}>
                                                                    <div className="move-on-hover">
                                                                        <i className="fa-solid fa-trash fa-2x"></i>
                                                                    </div>
                                                                    <div className="mt-2 ms-2">
                                                                        <h4 className="mb-0">Deleted Policies</h4>
                                                                    </div>

                                                                </a>
                                                            </div>
                                                            <div className="col-md-3 p-4 mt-md-0 mr-5" style={{
                                                                backgroundColor: "#f6f3f3",
                                                                borderRadius: '2.5%'
                                                            }}>
                                                                <a href={'/claims-turn-around'}>
                                                                    <div className="move-on-hover">
                                                                        <i className="fa-solid fa-arrows-turn-to-dots fa-2x"></i>

                                                                    </div>
                                                                    <div className="mt-2 ms-2">
                                                                        <h4 className="mb-0">Claims Turn Around</h4>
                                                                    </div>

                                                                </a>
                                                            </div>
                                                        </div>

                                                    </div>
                                        </div>
                                    </div>
                                    {/*    end tabs*/}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    )

}

export default Reports
